import { Breadcrumb } from '../../components/Breadcrumb'
import { AiProviderKeysSection } from '../../components/AiProviderKeysSection'

/**
 * Company Admin AI Provider Keys page.
 *
 * Pared down to the AI provider keys feature only. The old
 * "TaskMagix API Keys" section (outbound integration tokens that let
 * external systems call the TaskMagix API on the tenant's behalf)
 * was removed by request — those keys + the underlying
 * `/api-keys` POST/DELETE/revoke routes still exist server-side
 * (api-keys.routes.js / api-keys.service.js), they're just no
 * longer surfaced on this page. Re-mount the old listing if you
 * ever want it back — the data model is untouched.
 *
 * No page-level <h1>: AiProviderKeysSection renders its own header
 * (icon + "AI Provider Keys" + status pill), so a separate page title
 * would just duplicate it. The breadcrumb + sidebar carry the page name.
 */
export function ApiKeysPage() {
  return (
    <div>
      <Breadcrumb current="AI Provider Keys" />
      <AiProviderKeysSection />
    </div>
  )
}
